var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container" }, [
    _c("div", { staticClass: "detail-header" }, [
      _c("div", { staticClass: "header-left" }, [
        _c(
          "span",
          { staticStyle: { "font-size": "16px", "font-weight": "bold" } },
          [
            _vm._v(
              _vm._s(_vm.childData.areaName) +
                " " +
                _vm._s(
                  _vm.childData.areaName !== _vm.childData.areaGroupName
                    ? _vm.childData.areaGroupName
                    : ""
                ) +
                " " +
                _vm._s(_vm.childData.buildingName)
            )
          ]
        )
      ])
    ]),
    _c(
      "div",
      { staticClass: "information" },
      [
        _c(
          "el-col",
          {
            staticStyle: {
              "margin-bottom": "10px",
              "padding-top": "10px",
              color: "#333"
            },
            attrs: { span: 24 }
          },
          [
            _c("span", { staticStyle: { "font-size": "16px" } }, [
              _vm._v("基础信息")
            ])
          ]
        ),
        _c(
          "el-form",
          {
            ref: "dataForm",
            attrs: { "label-position": "right", "label-width": "130px" }
          },
          [
            _c(
              "el-col",
              { attrs: { span: 24 } },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: _vm.$t("table.directorialArea") } },
                  [_c("span", [_vm._v(_vm._s(_vm.childData.areaGroupName))])]
                )
              ],
              1
            ),
            _c(
              "el-col",
              { attrs: { span: 8 } },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: _vm.$t("table.buildingSeq") } },
                  [_c("span", [_vm._v(_vm._s(_vm.childData.buildingOrder))])]
                )
              ],
              1
            ),
            _c(
              "el-col",
              { attrs: { span: 8 } },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: _vm.$t("table.buildingFloor") } },
                  [_c("span", [_vm._v(_vm._s(_vm.childData.buildingFloors))])]
                )
              ],
              1
            ),
            _c(
              "el-col",
              { attrs: { span: 8 } },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: _vm.$t("table.buildingType") } },
                  [_c("span", [_vm._v(_vm._s(_vm.childData.buildingTypeName))])]
                )
              ],
              1
            ),
            _c(
              "el-col",
              { attrs: { span: 8 } },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: _vm.$t("table.buildingUse") } },
                  [_c("span", [_vm._v(_vm._s(_vm.childData.buildingUseName))])]
                )
              ],
              1
            ),
            _c(
              "el-col",
              { attrs: { span: 16 } },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: _vm.$t("table.orientation") } },
                  [
                    _c("span", [
                      _vm._v(_vm._s(_vm.childData.buildingTowardName))
                    ])
                  ]
                )
              ],
              1
            )
          ],
          1
        ),
        _c("el-col", { attrs: { span: 24 } }, [
          _c("span", { staticStyle: { "font-size": "16px" } }, [_vm._v("备注")])
        ]),
        _c("el-input", {
          staticStyle: { width: "880px", "margin-top": "1vw" },
          attrs: {
            disabled: "",
            maxlength: "100",
            type: "textarea",
            autosize: { minRows: 3, maxRows: 5 }
          },
          model: {
            value: _vm.childData.buildingRemark,
            callback: function($$v) {
              _vm.$set(_vm.childData, "buildingRemark", $$v)
            },
            expression: "childData.buildingRemark"
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }